import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { EdpCommunicationsConsentsModalComponent } from "@edp-components/edp-communications-consents-modal/edp-communications-consents-modal.component";
import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import {
    EdpEnvironmentSwitchModalComponent,
    EnvironmentDevList,
} from "@edp-components/edp-environment-switch-modal/edp-environment-switch-modal.component";
import { EdpLanguagesComponent } from "@edp-components/edp-languages/edp-languages.component";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { ContractStatusEnum } from "@edp-enums/contract-status-enum";
import { OnboardingTriggerUserEnum } from "@edp-enums/onboarding-trigger-user.enum";
import { RegionEnum } from "@edp-enums/region.enum";
import { environment } from "@edp-environments/environment";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { SolarAccountEs } from "@edp-models/ES/es-solar-account.model";
import { UserLevel } from "@edp-models/user-level.model";
import { EdpUser } from "@edp-models/user.model";
import { AppService } from "@edp-services/app.service";
import { AuthenticationService } from "@edp-services/authentication.service";
import { ContractDefineHouseV2Service } from "@edp-services/contract-define-house-v2.service";
import { EdpDefineHouseTermsConditionsService } from "@edp-services/edp-define-house-terms-conditions.service";
import { EnvService } from "@edp-services/env.service";
import { LanguageService } from "@edp-services/language.service";
import { OnboardingService } from "@edp-services/onboarding.service";
import { RegionService } from "@edp-services/region.service";
import { GetServiceAnswers } from "@edp-store/actions/define-house.action";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { LoadUserLevel } from "@edp-store/actions/levels.actions";
import { GetProfileStatus } from "@edp-store/actions/user.actions";
import { getContract, getContracts } from "@edp-store/selectors/contract.selectors";
import { getDefineHouseTermsConditions, getHouseStatusMoonshot } from "@edp-store/selectors/define-house.selector";
import { getContractEs, getContractsEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { getSolarAccountEs } from "@edp-store/selectors/ES/solar-account-es.selectors";
import { getLanguages } from "@edp-store/selectors/language.selectors";
import { getUserLevel } from "@edp-store/selectors/levels.selectors";
import { getUser, getUserEarlyAccess } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { IStatusMoonShot } from "@edp-store/state/define-house.state";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { DeviceDetectorService } from "ngx-device-detector";
import { Observable, Subject } from "rxjs";
import { filter, takeUntil, tap } from "rxjs/operators";
import { isLegalPersonNif } from "@edp-utils/is-legal-person-nif.util";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { TranslateService } from "@ngx-translate/core";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";

@Component({
    selector: "edp-overlay-user",
    templateUrl: "./edp-overlay-user.component.html",
    styleUrls: ["./edp-overlay-user.component.scss"],
})
export class EdpOverlayUserComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() public showLoader = new EventEmitter<boolean>();
    public userContracts: Contract[] = [];
    public thirdPartyContracts: Contract[] = [];
    public contractManagedByName: string;
    public customerName: string;
    public user: EdpUser;
    public contracts: Contract[];
    public contractStatusEnum = ContractStatusEnum;
    public hasEmployeeBenefit: boolean;
    public customerEmail: string;
    public managedBy: boolean;
    public paddingFix: boolean;
    public b2bUrl: string;
    private unsubscribe = new Subject();
    public isApp = false;
    public hasAppRecognition = false;
    public maxValue: number;
    public currentScore: number;
    public userLevel$: Observable<UserLevel>;
    private loadedLevels: Subject<void> = new Subject();
    public levelColor = "#225E66";
    public shadowLevelColor = "rgba(71, 144, 90, 0.5)";
    public userLanguageLabel: string;
    private selectedContract: Contract;
    /* ES */
    public selectedContractES: ContractEs;
    public solarAccountES: SolarAccountEs;
    /* ES */

    public showGiveFeedbackButton: boolean;

    public isBetaUser: boolean;
    public termsAndConditions: boolean = false;
    public statusMoonshot$: Observable<IStatusMoonShot> = null;
    public contractsEs: any;

    public constructor(
        private readonly store: Store<IAppState>,
        private readonly storeEs: Store<IAppEsState>,
        private readonly authenticationService: AuthenticationService,
        private readonly edpModalService: EdpModalService,
        private readonly router: Router,
        private readonly languageService: LanguageService,
        private readonly envService: EnvService,
        private readonly regionService: RegionService,
        private readonly onboardingService: OnboardingService,
        private readonly appService: AppService,
        private readonly deviceDetector: DeviceDetectorService,
        private readonly toasterService: EdpToasterService,
        private readonly translateService: TranslateService,
        private readonly edpDefineHouseTermsConditionsService: EdpDefineHouseTermsConditionsService,
        private contractDefineHouseService: ContractDefineHouseV2Service
    ) {
        this.userLevel$ = this.store.pipe(select(getUserLevel));
        this.getUserLangageLabel();
        this.getContractByRegion();
    }

    public ngOnInit(): void {
        this.isApp = environment.isApp;
        this.getHasRecoginitionAvailable();
        this.store.dispatch(new GetProfileStatus());
        this.store.dispatch(new LoadUserLevel());
        this.loadUserLevels();
        this.getUserContracts();
        this.getUser();
        this.getUserEarlyAccess();

        if (sessionStorage.getItem("profileCC")) {
            this.openTerms();
            sessionStorage.removeItem("profileCC");
        }

        this.onboardingService.registerUserAction(OnboardingTriggerUserEnum.PROFILE_3M).subscribe();

        this.store.pipe(select(getDefineHouseTermsConditions)).subscribe(terms => {
            this.termsAndConditions = terms;
        });

        this.statusMoonshot$ = this.store.pipe(select(getHouseStatusMoonshot));

        this.statusMoonshot$ = this.store.pipe(
            select(getHouseStatusMoonshot),
            tap(status => {
                if (!status) {
                    this.store.dispatch(new GetServiceAnswers());
                }
            })
        );
    }

    public ngAfterViewInit() {
        this.showGiveFeedbackButton = this.appService.checkKampyleLoad();
    }

    public ngOnDestroy() {
        this.loadedLevels.next();
        this.loadedLevels.complete();
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    private getUser(): void {
        this.store
            .pipe(
                takeUntil(this.unsubscribe),
                select(getUser),
                filter(val => val !== null && val !== undefined)
            )
            .subscribe(user => {
                this.user = user;
                this.customerName = `${this.user.firstname} ${this.user.lastname}`;
                this.paddingFix = this.user.photoURL ? true : false;

                this.b2bUrl = user.hasBusinessSegment() ? this.envService.b2bUrl() : null;

                this.levelColor = this.getLevelColor(this.user.edpELevel);
                this.shadowLevelColor = this.getLevelShadowColor();
            });

        // this.loadUserLevels();

        // if (sessionStorage.getItem("profileCC")) {
        //     this.openTerms();
        //     sessionStorage.removeItem("profileCC");
        // }

        // this.getHasRecoginitionAvailable();
        // this.onboardingService.registerUserAction(OnboardingTriggerUserEnum.PROFILE_3M).subscribe();
    }

    private getUserContracts(): void {
        this.store
            .pipe(
                takeUntil(this.unsubscribe),
                select(getContracts),
                filter(val => val !== null && val !== undefined)
            )
            .subscribe((contracts: Contract[]) => {
                if (contracts) {
                    this.userContracts = [];
                    this.thirdPartyContracts = [];
                    this.checkContracts(contracts);
                }
            });
    }

    private getUserEarlyAccess(): void {
        this.store.pipe(takeUntil(this.unsubscribe), select(getUserEarlyAccess)).subscribe((earlyAccess: string) => {
            this.isBetaUser = earlyAccess === "MOONSHOT";
        });
    }

    private getHasRecoginitionAvailable(): void {
        if (this.isApp) {
            this.appService.getAppHasRecoginitionAvailable()?.subscribe((available: boolean) => (this.hasAppRecognition = available));
        }
    }

    private getContractByRegion(): void {
        if (this.regionService.getRegion() === RegionEnum.ES) {
            this.storeEs.pipe(select(getSolarAccountEs)).subscribe((solarAccountES: SolarAccountEs) => {
                if (!!solarAccountES) {
                    this.solarAccountES = solarAccountES;
                }
            });
            this.storeEs.pipe(select(getContractEs)).subscribe((contract: ContractEs) => {
                if (!!contract) {
                    this.selectedContractES = contract;
                }
            });
            this.storeEs.pipe(select(getContractsEs)).subscribe((contracts: ContractEs[]) => {
                if (!!contracts) {
                    this.contractsEs = contracts;
                }
            });
            return;
        }

        this.store.pipe(select(getContract)).subscribe((contract: Contract) => {
            if (!!contract) {
                this.selectedContract = contract;
            }
        });

        this.store
            .pipe(
                takeUntil(this.unsubscribe),
                select(getContracts),
                filter(val => val !== null && val !== undefined)
            )
            .subscribe((contracts: Contract[]) => {
                if (contracts) {
                    this.userContracts = [];
                    this.thirdPartyContracts = [];
                    this.checkContracts(contracts);
                }
            });
    }

    private getUserLangageLabel(): void {
        const userLanguage = this.languageService.getUserLanguage();
        this.store.pipe(select(getLanguages)).subscribe(data => {
            if (!!data) {
                this.userLanguageLabel = data.find(i => i.language_key === userLanguage)?.language_label;
            }
        });
    }

    public logout(): void {
        const isApp = environment.isApp;
        if (isApp && this.hasAppRecognition) {
            this.appService.deleteRecoginitionDefined();
        }
        this.showLoader.emit(true);
        this.appService.logout();
        this.authenticationService.logout().subscribe(() => {
            const logoutUrl = `${this.envService.ssoUrl()}/logout`;
            window.location.href = isApp ? `${logoutUrl}?Mobile=1` : logoutUrl;
        });
    }

    public loadUserLevels() {
        if (this.loadedLevels) {
            this.userLevel$.pipe(takeUntil(this.loadedLevels)).subscribe(userLevel => {
                if (userLevel) {
                    this.maxValue = userLevel.levels[userLevel.levels.length - 1].score;
                    this.currentScore = userLevel.currentScore;
                }
            });
        }
    }

    private redirectProfileIos(): void {
        window.location.href = `${this.envService.ssoUrl()}/profile`;
    }

    public editProfile(): void {
        const isIOS =
            this.deviceDetector.device === "iPhone" ||
            this.deviceDetector.getDeviceInfo().os.toLowerCase() === "ios" ||
            navigator.platform.toLocaleLowerCase().includes("mac");

        if (isIOS) {
            this.redirectProfileIos();
            return;
        }
        this.store.dispatch(new SelectOverlayAction(null));
        this.router.navigate(["editar-perfil"]);
    }

    public moreInfo(): void {
        this.router.navigate([`/locais-consumo/${this.selectedContract.ContractId}/inicio`]);
    }

    public goToProfileRecognition(): void {
        this.router.navigate(["biometria"]);
    }

    public switchEnvironment(): void {
        if (EnvironmentDevList.available()) {
            this.edpModalService.custom(EdpEnvironmentSwitchModalComponent, {}, {}).then();
        }
    }

    public goToLevelsPage() {
        this.router.navigateByUrl("planeta-zero/seu-nivel");
        this.store.dispatch(new SelectOverlayAction(null));
    }

    private checkContracts(contracts: Contract[]): void {
        contracts.forEach((contract: Contract) => {
            if (contract.Status === ContractStatusEnum.ACTIVE || contract.Status === ContractStatusEnum.IN_ACTIVATION) {
                // Save contracts that are managed by the current user.
                if (!contract.IsManaged || (contract.IsManaged && !contract.IsManagedByMe)) {
                    this.userContracts.push(contract);
                } else {
                    this.thirdPartyContracts.push(contract);
                }
            }
        });

        // Check if at least one contract of the userContracts list are managed by third parties.
        if (this.userContracts.length > 0) {
            const listUserContractsManagedBy: Contract[] = this.isManageByThirdParties();

            if (listUserContractsManagedBy.length > 0) {
                this.managedBy = true;
                const firstName: string = listUserContractsManagedBy[0].IsManagedBy.firstName;
                const lastName: string[] = listUserContractsManagedBy[0].IsManagedBy.lastName.split(" ");
                this.contractManagedByName = `${firstName} ${lastName[lastName.length - 1]}`;
            }

            // Verify if the current employee have at least one benefit.
            this.hasEmployeeBenefit = this.userContracts.filter(contract => contract.EmployeeBenefit).length > 0;
        }
    }

    private isManageByThirdParties(): Contract[] {
        return this.userContracts.filter(contract => contract.IsManagedByMe === false);
    }

    private getLevelColor(level) {
        switch (level) {
            case "1":
                return "#225E66";
            case "2":
                return "#225E66";
            case "3":
                return "#225E66";
            case "4":
            default:
                return "#225E66";
        }
    }

    private getLevelShadowColor() {
        switch (this.user.edpELevel) {
            case "1":
                return "rgba(34, 94, 102, 0.5)";
            case "2":
                return "rgba(34, 94, 102, 0.5)";
            case "3":
                return "rgba(34, 94, 102, 0.5)";
            case "4":
            default:
                return "rgba(34, 94, 102, 0.5)";
        }
    }

    public openTerms() {
        const isLegalPerson = isLegalPersonNif(this.selectedContract.OwnerNif);
        if (isLegalPerson) {
            this.toasterService
                .create(this.translateService.instant("pt.edp.edponline.overlay.user.legal.person.term.message"), EdpToastType.info)
                .show();
            return;
        }

        const options: NgbModalOptions = {
            windowClass: "edp-dialog-fullscreen",
            keyboard: true,
        };

        const modalData: IModalData = {
            showClose: true,
        };

        this.edpModalService.custom(EdpCommunicationsConsentsModalComponent, options, modalData);
    }

    public openB2B(url) {
        window.open(url, "_blank");
    }

    public openHouseDetails() {
        sessionStorage.setItem("new-local-house-back", "PROFILE");

        if (!this.isBetaUser) {
            this.router.navigate([`/locais-consumo/${this.selectedContract.ContractId}/casa/alteracao`]);
            return;
        }

        if (!this.termsAndConditions && this.isBetaUser) {
            this.edpDefineHouseTermsConditionsService.showTermsConditionsModal();
            return;
        }

        const args = {
            account: this.selectedContract.AccountNumber,
            events: [
                {
                    event: "start_dialogue",
                },
            ],
        };

        this.contractDefineHouseService.postContractDefineDataWtLoader(args).subscribe(
            res => {
                this.router.navigate([`/locais-consumo/${this.selectedContract.ContractId}/casa/alteracao/beta/casa`]);
            },
            error => {
                console.error(error);
            }
        );
    }

    public openModalLanguages() {
        this.languageService.sendOperationHistoryService("Click_button_language", "");
        const options: NgbModalOptions = {
            windowClass: "edp-dialog-fullscreen",
        };

        this.edpModalService.custom(EdpLanguagesComponent, options, {});
    }

    public getExtraGaClickDatalayer(): { formModal: string } {
        return {
            formModal: `/locais-consumo/${this.selectedContract.ContractId}/casa/alteracao`,
        };
    }

    public onGiveFeedBack() {
        this.appService.showKampyleFeedbackForm();
    }
}
